<script>
import CampaignLayout from "../../components/CampaignLayout";
import { useRoute } from "vue-router";
import CheckInCampaing from '../../components/Campaign/CheckInCampaing.vue';
import CheckOutCampaing from '../../components/Campaign/CheckOutCampaing.vue';

export default {
  name: "Menu",
  data() {
    return {
      showList1: false,
      showList2: false,
    };
  },
  components: {
    CampaignLayout,
    CheckInCampaing,
    CheckOutCampaing,
  },
  setup() {
    const route = useRoute();
    const { id } = route.params;
    return { id, route };
  },
  created() {},
  ionViewWillEnter() {},
  methods: {},
  computed: {
    computed_debug() {
      if (this.$cookies.get("debug") == 1) {
        return false;
      } else {
        return true;
      }
    },

    renderComponent() {
      const path = this.route.path;
      if (path.includes("check-in")) {
        return "check-in";
      } else if (path.includes("check-out")) {
        return "check-out";
      }
      return null;
    },
  },
};
</script>

<template>
  <campaign-layout
    :showMenu="computed_debug"
    :showBack="computed_debug"
    pageTitle="Checkin/Checkout"
  >
    <check-in-campaing v-if="renderComponent === 'check-in'"></check-in-campaing>
    <check-out-campaing v-if="renderComponent === 'check-out'"></check-out-campaing>
  </campaign-layout>
</template>

<style>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
